import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Delete, Pencil } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { Dimension } from 'modules/finance/pages/DimensionDetailPage/DimensionDetail/useDimensionDetail'

interface Props {
  dimension: Dimension
}

const Header = ({ dimension }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <ResourceHeader
      title={dimension.name}
      description={i18n.t('finance.dimension_detail.description')}
      secondaryActions={[
        {
          icon: Delete,
          label: i18n.t('common.delete'),
          variant: 'critical',
          onClick: () => {
            navigate(
              navigation.settings.finance.dimensions.dimension.delete.fullPath({
                id: dimension.id,
              })
            )
          },
        },
        {
          icon: Pencil,
          label: i18n.t('common.edit'),
          onClick: () => {
            navigate(
              navigation.settings.finance.dimensions.dimension.edit.fullPath({
                id: dimension.id,
              })
            )
          },
        },
      ]}
    />
  )
}

export default Header
